import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white py-8">
      <div className="container mx-auto px-6">
        <div className="text-center">
          <p className="text-gray-400 text-sm">
            © {currentYear} Diksha Bidikar. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;